module.exports = __webpack_public_path__ + "static/img/c1.28b43661.webp";